import { render, staticRenderFns } from "./JcdcLabeledTextPair.vue?vue&type=template&id=466dfe29"
import script from "./JcdcLabeledTextPair.vue?vue&type=script&lang=ts"
export * from "./JcdcLabeledTextPair.vue?vue&type=script&lang=ts"
import style0 from "./JcdcLabeledTextPair.vue?vue&type=style&index=0&id=466dfe29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports